import script from "./WagerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WagerCard.vue?vue&type=script&setup=true&lang=ts"

import "./WagerCard.vue?vue&type=style&index=0&id=093ba476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093ba476"]])

export default __exports__